// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TReductoWebhookRequestPayload,
  TReductoWebhookResponsePayload,
} from './reducto-webhook.types.ts';

export const createReductoWebhookApi = (transport: TApiTransport) => ({
  /** Document-processing (Reducto) webhook */
  reductoWebhook: (
    payload: TReductoWebhookRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TReductoWebhookRequestPayload,
      TReductoWebhookResponsePayload
    >('/reducto_webhook', payload, options),
});
